import React from "react";
import Dialog from "../../../atoms/dialog";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import { AddTransactionWithinATransaction, ImportTransaction } from "./Create";
import { useDispatch, useSelector } from "react-redux";
import { reRenderInfoBuilder, setDrawNestedTransaction, setDrawReuseTransaction, setDrawnTransaction, handleSnackBar } from "../../../../store/global/actions";
import { getTransactionState, getTransactionDrawnState, getParentTransaction } from "../../../../store/global/selectors";
import { onNestedTransactionDelete, onInvokedTransactionDelete } from "../../../../store/constructs/transactions/actions";
import { getTransaction } from "../../../../store/constructs/transactions/selectors";
import TemplateTransactionSelector from './TemplateTransactionSelector';
import { invokePostService, setReRender } from "../../../../store/global/actions";
import { useParams } from 'react-router-dom';


const Transaction = (props) => {
	// console.log("--------------------Transaction----------------------")
	const [step, setStep] = React.useState(0);
	const [selected, setSelected] = React.useState(null);
	const [edit, setEdit] = React.useState(null);
	const [callbackEnabled, setCallbackEnabled] = React.useState(null);
	const submitRef = React.useRef(null);
	const { open, onToggleAddAlreadyDelcaredTransaction, handleClose, transactionYPosition, openMainTransaction } = props;
	const [forDelete, setforDelete] = React.useState(0);
	// const [uuidDel, setuuidDel] = React.useState('');
	const [deleteState, setDelete] = React.useState(true);
	const [forImportTransaction, setforImportTransaction] = React.useState(0);
	const [embedTransaction, setembedTransaction] = React.useState();
	const [condition, setcondition] = React.useState("");
	const [embeddedUUid, setEmbeddedUuid] = React.useState();
	const [disableEdit, setDisableEdit] = React.useState();

	const uuid = require("short-uuid");
	const [dialogTitle, setDialogTitle] = React.useState('Transaction');

	const transactionState = useSelector(getTransactionState);
	const transDrawnState = useSelector(getTransactionDrawnState);
	const parentTransaction = useSelector(getParentTransaction);

	React.useEffect(() => {

		if (open && typeof open === "string") {
			const openUuid = open.replace("draw-", '')
			if (open.indexOf("-") > -1) {

				const [key, val] = open.split("-");
				if (openUuid) setEdit(openUuid);
				setStep(1);
				setSelected(key);
			}
		}
		else {

			if (openMainTransaction) {
				setStep(1)
				setSelected('create')
			} else {
				setStep(0);
				setforDelete(0);
			}

		}
	}, [open]);

	React.useEffect(() => {

		if (transactionState.drawNestedTransaction) {
			setDialogTitle('Child transaction');
		} else if (transactionState.drawReuseTransaction) {
			setDialogTitle('Invoke transaction');
		} else if (transactionState.drawTemplateTransaction) {
			setDialogTitle('Import transaction from template');
		}

	}, [transactionState])

	const dispatch = useDispatch();
	const params = useParams();

	const listTrans = useSelector(getTransaction);

	const stepController = (key) => {
		switch (key) {
			case "next":
				setEdit(null);
				setStep((prev) => prev + 1);
				break;
			case "back":
				setStep((prev) => prev - 1);
				setforDelete(0);
				setforImportTransaction(0);
				setEdit(null);
				break;
		}
	};

	const handleDelete = () => {
		setDelete((prev) => !prev);
	};

	const reset = () => {
		setStep(0);
		handleClose();
		setforImportTransaction(0);
		setSelected(null);
	};

	const goToCreateMenu = () => {
		setStep(1);
		setSelected("create");

		function callback() {
			setStep(1);
			setSelected("inserted");
		}

		setCallbackEnabled({ current: callback });
	};

	const onSubmit = () => {
		if (submitRef && submitRef.current) {
			submitRef.current(callbackEnabled)
		}
	};

	const onDeleteNestedTrans = () => {

		let isInvoked = false;
		const id = open.split("-")
		const selectedTransactionId = props.selected.id

		listTrans.forEach((tr, index) => {
			if (tr.id === id[1]) {
				isInvoked = true;
			}
		})

		if (isInvoked) {
			dispatch(onInvokedTransactionDelete(id[1], selectedTransactionId));
		}
		else {
			dispatch(onNestedTransactionDelete(id[1], selectedTransactionId));
		}
		//dispatch(onInnerTransctionDelete(id[1], selectedTransactionId));
		handleClose()
		setStep(0);
		setSelected(null);
		dispatch(reRenderInfoBuilder())
	}

	const onImportTransaction = () => {

		//const mainTrans_uuid = props.selected.uuid;
		const mainTrans_uuid = props.selected.id;
		const selectedOne = props.selected;

		let referenceUuid = "";

		let x_cordinate = 0;
		let y_cordinate = 0;

		if (x_cordinate == 0) { x_cordinate = 397.37 }
		if (y_cordinate == 0) { y_cordinate = 70 }


		//const highestOrder =  createOrder(selectedOne);		
		const highestOrder = props.transactionYPosition
		const invokedTransaction = {
			id: embedTransaction[0]._id,
			condition: condition,
			order: highestOrder,
		}

		// console.log('tra----->', invokedTransaction)

		//dispatch(onTransactionReuse(mainTrans_uuid,jsonElement,embedTransElement,eventsElement));
		// dispatch(onTransactionInvoke(mainTrans_uuid, invokedTransaction));
		dispatch(invokePostService('createInvokedTransaction', { invokedTransaction: embedTransaction[0]._id, order: highestOrder, condition: condition, parentTransaction: parentTransaction != '' ? parentTransaction : params.transaction }, []))
			.then(savedData => {
				console.log("saved data-----", savedData);
				if(savedData.status != undefined && savedData.status == false && savedData.message != undefined){
					dispatch(handleSnackBar({ message: savedData.message, severity: 'error' }));
				}
				else{
					dispatch(setReRender());
				}
			})
			.catch(error => console.error(error));
		// dispatch(reRenderInfoBuilder())
		handleClose()
		setStep(0);
		setSelected(null);

	}

	const closeDialog = () => {
		dispatch(setDrawNestedTransaction(false))
		dispatch(setDrawReuseTransaction(false))
		dispatch(setDrawnTransaction(false))
		setStep(0);
		dispatch(reRenderInfoBuilder())
		handleClose();
	}

	return (
		<React.Fragment>
			{/* {deleteState && <Dialog */}
			{((transactionState.drawNestedTransaction && transDrawnState) || (transactionState.drawReuseTransaction && transDrawnState) || (transactionState.drawTemplateTransaction && transDrawnState)) && <Dialog
				title={dialogTitle}
				open={Boolean(open)}
				handleClose={closeDialog}
				actions={
					<>
						{transactionState.drawTemplateTransaction == false && <>
							<Button variant="contained" onClick={closeDialog} style={{textTransform: 'capitalize'}} >
								Cancel
							</Button>
							<Button variant="contained" color="primary" onClick={forImportTransaction == 1 ? onImportTransaction : onSubmit}  style={{textTransform: 'capitalize'}} >
								{forImportTransaction == 1 ? "Use" : "Save"}
							</Button>
						</>}
					</>
				}
			>
				<Slide direction="right" in={true} mountOnEnter unmountOnExit>
					<RefErrorWrapper>

						{transactionState.drawNestedTransaction && <AddTransactionWithinATransaction open={edit} handleClose={reset} submitRef={submitRef} selected={props.selected} contentOnly forDel={setforDelete} forImport={setforImportTransaction} transactionYPosition={transactionYPosition} />}

						{transactionState.drawReuseTransaction && <ImportTransaction open={edit} handleClose={reset} selected={props.selected} forImport={setforImportTransaction} forDel={setforDelete} embeded={setembedTransaction} con={setcondition} contentOnly transactionYPosition={transactionYPosition} />}

						{transactionState.drawTemplateTransaction && <TemplateTransactionSelector handleClose={reset} currentTransaction={props.selected} transactionYPosition={transactionYPosition} />}

					</RefErrorWrapper>
				</Slide>
			</Dialog>}
		</React.Fragment>
	);
};

export default Transaction;

class RefErrorWrapper extends React.PureComponent {
	constructor(props) {
		super(props);
	}
	render() {
		return <div>{this.props.children}</div>;
	}
}
